import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { PActionButtonModule } from '@panaya/ui/p-action-button';

@Component({
    standalone: true,
    selector: 'p-file-upload-button',
    imports: [PActionButtonModule, FormsModule, TranslateModule],
    templateUrl: './p-file-upload-button.component.html',
    styleUrls: ['./p-file-upload-button.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PFileUploadButtonComponent {
    @Output() public fileSelected = new EventEmitter<File>();

    protected onFileSelected(event: Event): void {
        const input = event.target as HTMLInputElement;
        if (input.files?.length) {
            const file = input.files[0];
            this.fileSelected.emit(file);
            input.value = '';
        }
    }
}
